import { render } from "./CustomerView.vue?vue&type=template&id=e8128d7c&scoped=true"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"

import "./CustomerView.vue?vue&type=style&index=0&id=e8128d7c&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8128d7c"]])

export default __exports__